export default {
  title: 'Pushmeldingen',
  description: 'Stuur gerichte pushmeldingen naar uw klanten',
  buttons: {
    new_campaign: 'Nieuwe campagne',
  },
  error_messages: {
    no_mobile_app: {
      title: 'Mobiele app nog niet live',
      description: 'Wacht tot de mobiele app live is voordat u pushmeldingen kunt verzenden',
    },
  },
};
